import { GET_API, POST_API } from "../utils/api";
import { API_DOMAIN } from "../utils/domain";

// Fetch brands and products from local API
export const fetchBrandsProducts = async () => {
  try {

    const response = await fetch(`${API_DOMAIN}/brands-products`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Brands-Products API response:', result);

    if (result.success && result.data) {
      return {
        success: true,
        message: 'Brands and products retrieved successfully',
        data: result.data,
      };
    } else {
      return {
        success: false,
        message: result.message || 'Failed to fetch brands and products',
      };
    }
  } catch (error) {
    console.error('Error fetching brands and products:', error);
    return {
      success: false,
      message: 'Error fetching brands and products. Please try again later.',
    };
  }
};

// Fetch all vendors (search products to get vendor list)
export const fetchVendors = async (query = "", page = 1, resultsPerPage = 100) => {
  try {
    const requestBody = {
      query: query,
      searchType: "vpv",
      exactMatch: false,
      resultsPerPage: resultsPerPage,
      page: page
    };

    console.log('Fetching vendors from:', `${API_DOMAIN}/api/v1/cvedetails/product/search`);
    console.log('Request body:', requestBody);

    const result = await POST_API(`${API_DOMAIN}/api/v1/cvedetails/product/search`, requestBody);
    console.log('Vendors API response:', result);

    if (result.success && result.data && result.data.results) {
      // Extract unique vendors from results
      const vendorsMap = new Map();
      result.data.results.forEach(item => {
        if (item.vendorName && !vendorsMap.has(item.vendorId)) {
          vendorsMap.set(item.vendorId, item.vendorName);
        }
      });

      const vendors = Array.from(vendorsMap.values());
      console.log('Extracted vendors:', vendors);

      return {
        success: true,
        message: result.message || 'Vendors retrieved successfully',
        data: vendors,
        metadata: {
          limit: result.data.limit,
          offset: result.data.offset,
          totalResults: result.data.results.length
        }
      };
    } else {
      console.log('Vendors fetch failed:', result.message);
      return {
        success: false,
        message: result.message || 'Failed to fetch vendors',
      };
    }
  } catch (error) {
    console.error('Error fetching vendors:', error);
    return {
      success: false,
      message: 'Error fetching vendors. Please try again later.',
    };
  }
};

// Fetch vendor data (products and versions) by vendor name
export const fetchVendorData = async (vendorName) => {
  try {
    console.log('Fetching vendor data for:', vendorName);
    const result = await POST_API(`${API_DOMAIN}/api/vendor`, {
      vendor: vendorName
    });
    console.log('Vendor data API response:', result);

    if (result.success && result.data && result.data.length > 0) {
      const vendorData = result.data[0];
      console.log('Vendor data:', vendorData);

      return {
        success: true,
        message: 'Vendor data retrieved successfully',
        data: vendorData,
      };
    } else {
      return {
        success: false,
        message: result.message || 'Failed to fetch vendor data',
      };
    }
  } catch (error) {
    console.error('Error fetching vendor data:', error);
    return {
      success: false,
      message: 'Error fetching vendor data. Please try again later.',
    };
  }
};

// Fetch product versions by product ID
export const fetchProductVersions = async (productId, noVulns = true, pageNumber = 1, resultsPerPage = 20) => {
  try {
    const requestBody = {
      productId: productId,
      noVulns: noVulns,
      pageNumber: pageNumber,
      resultsPerPage: resultsPerPage
    };

    console.log('Fetching product versions from:', `${API_DOMAIN}/api/v1/cvedetails/product/versions`);
    console.log('Request body:', requestBody);

    const result = await POST_API(`${API_DOMAIN}/api/v1/cvedetails/product/versions`, requestBody);
    console.log('Product versions API response:', result);

    if (result.success && result.data && result.data.results) {
      return {
        success: true,
        message: result.message || 'Product versions retrieved successfully',
        data: result.data.results,
        metadata: {
          limit: result.data.limit,
          offset: result.data.offset,
          totalResults: result.data.results.length
        }
      };
    } else {
      console.log('Product versions fetch failed:', result.message);
      return {
        success: false,
        message: result.message || 'Failed to fetch product versions',
      };
    }
  } catch (error) {
    console.error('Error fetching product versions:', error);
    return {
      success: false,
      message: 'Error fetching product versions. Please try again later.',
    };
  }
};
